import api from 'src/utils/api/core'

export function getTideRateStations(portUuid) {
  return api.get(`/tide_rate_stations?portUuid=${portUuid}`)
}
